import React from 'react'
import { useSearchParams } from 'react-router-dom'

import JobCard from './Card'
import JobOfferFilters from './Filters'
import Loading from '../../components/layout/Loading'
import * as jobOffersLib from '../../../libraries/job-offers'
import * as urlLib from '../../../libraries/url'
import ResultsLabel from '../../components/grid/ResultsLabel'
import { useAllJobOfferApplications, useJobOffer, useJobOfferEngagements, useJobOffers } from './hooks'
import { useJobOfferFilter } from '../../../libraries/search/filters'
import NoResults from '../../components/layout/NoResults'
import { JobOfferFilter } from '../../../api/job-offers/types'

type Props = { defaultFilters?: Partial<JobOfferFilter> }
let sort = true
const AllJobOffers:React.FC<Props> = ({ defaultFilters = {} }) => {
  const { filters, setFilters } = useJobOfferFilter()
  const [urlSearchParams, setUrlSearchParams] = useSearchParams()
  const jobOfferIdOpened = urlSearchParams.get('jobId') ? parseInt(urlSearchParams.get('jobId') as string) : null
  const [defaultToFirstPos] = React.useState(jobOfferIdOpened) // ?jobId is used to open a job offer by default on first render that job is moved to first position
  const { data: allJobOffers, isLoading } = useJobOffers()
  const { data: jobOfferOpened, isLoading: loadingJobOpened } = useJobOffer(jobOfferIdOpened)
  const { data: jobOfferApplications, isLoading: loadingJobOfferApplications } = useAllJobOfferApplications()
  const { data: jobOfferEngagements, isLoading: loadingJobOfferEngagements } = useJobOfferEngagements()

  React.useEffect(() => { setFilters(defaultFilters) }, [])

  if(isLoading || loadingJobOfferApplications || loadingJobOfferEngagements) {
    return <Loading size='fill-container' />
  }
  if(!allJobOffers) return null

  const handleJobOfferClick = (jobId: number) => {
    sort = false
    if(jobOfferIdOpened === jobId) {
      urlSearchParams.delete('jobId')
      setUrlSearchParams(urlSearchParams, { replace: true })
    } else {
      setUrlSearchParams(urlLib.buildUrlParams({ jobId: jobId.toString() }, urlSearchParams), { replace: true })
    }
  }

  const totalResultsWithDefaultFilters = jobOffersLib.filterJobOffers(allJobOffers, jobOfferApplications, jobOfferEngagements, defaultFilters)?.length
  const filteredJobOffers = jobOffersLib.filterJobOffers(allJobOffers, jobOfferApplications, jobOfferEngagements, filters)
  const sortedJobOffers = sort ? filteredJobOffers.sort((a) => defaultToFirstPos ===  a.id ? -1 : 0) : filteredJobOffers
  const handleClearFilters = () => {
    setFilters(defaultFilters, true)
  }

  return (
    <>
      <JobOfferFilters />
      <div className='mb-4'>
        {filteredJobOffers?.length === 0
          ? <NoResults onClearFilter={handleClearFilters} totalResults={totalResultsWithDefaultFilters} />
          : <ResultsLabel amount={filteredJobOffers?.length} />
        }
      </div>
      <div className='flex flex-col gap-y-4'>
        {sortedJobOffers
          .map((jobOffer) => {
            const isOpened = jobOfferIdOpened === jobOffer.id
            return (
              <JobCard
                key={jobOffer.id}
                onClick={handleJobOfferClick}
                jobOffer={jobOffer}
                jobOfferOpened={jobOfferOpened}
                isOpened={isOpened}
                isLoading={loadingJobOpened}
                applied={
                  !!jobOfferApplications?.find((jobOfferApplication) => jobOfferApplication.jobOfferId === jobOffer.id)
                }
                engaged={
                  !!jobOfferEngagements?.find((jobOfferEngagement) => jobOfferEngagement.jobOfferId === jobOffer.id)
                }
              />
            )
          })
        }
      </div>
    </>
  )
}

export default AllJobOffers
